import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import login from '@/views/login'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//----------------

Vue.use(Router)



let router = new Router({
  routes: [{
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/',
      redirect: '/login',
      name: 'index',
      component: index,
      meta: {
        isLogin: true // 添加该字段，表示进入这个路由是需要登录的
      },
      children: [{
          path: '/sy/sy',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'sy',
          component: () => import( /* webpackChunkName: "statement" */ '../views/sy/sy.vue')
        },
        {
          path: '/Administration/jsJl',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'jsJl',
          component: () => import( /* webpackChunkName: "statement" */ '../views/Administration/jsJl.vue')
        },
        {
          path: '/Administration/incom',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'incom',
          component: () => import( /* webpackChunkName: "statement" */ '../views/Administration/incom.vue')
        },
        {
          path: '/Administration/mallAdmin',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'mallAdmin',
          component: () => import( /* webpackChunkName: "statement" */ '../views/Administration/mallAdmin.vue')
        },
        {
          path: '/Administration/shFx',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'shFx',
          component: () => import( /* webpackChunkName: "statement" */ '../views/Administration/shFx.vue')
        },
        {
          path: '/Administration/zfLs',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'zfLs',
          component: () => import( /* webpackChunkName: "statement" */ '../views/Administration/zfLs.vue')
        },
        {
          path: '/Administration/zfLsXq',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'zfLsXq',
          component: () => import( /* webpackChunkName: "statement" */ '../views/Administration/zfLsXq.vue')
        },
        // {
        //   path: '/Administration/zfLsXq2',
        //   meta: {
        //     isLogin: true // 添加该字段，表示进入这个路由是需要登录的
        //   },
        //   name: 'zfLsXq2',
        //   component: () => import( /* webpackChunkName: "statement" */ '../views/Administration/zfLsXq2.vue')
        // },
        {
          path: '/Administration/salesroom',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'salesroom',
          component: () => import( /* webpackChunkName: "statement" */ '../views/Administration/salesroom.vue')
        },
        {
          path: '/Administration/mdYg',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'mdYg',
          component: () => import( /* webpackChunkName: "statement" */ '../views/Administration/mdYg.vue')
        },
        // 下级机构
        {
          path: '/subOrg/xjDl',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'xjDl',
          component: () => import( /* webpackChunkName: "statement" */ '../views/subOrg/xjDl.vue')
        },
        {
          path: '/subOrg/appForCommission',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'appForCommission',
          component: () => import( /* webpackChunkName: "statement" */ '../views/subOrg/appForCommission.vue')
        },
        {
          path: '/subOrg/jyFy',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'jyFy',
          component: () => import( /* webpackChunkName: "statement" */ '../views/subOrg/jyFy.vue')
        },
        {
          path: '/subOrg/jyFy1',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'jyFy1',
          component: () => import( /* webpackChunkName: "statement" */ '../views/subOrg/jyFy1.vue')
        },
        {
          path: '/subOrg/jgYg',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'jgYg',
          component: () => import( /* webpackChunkName: "statement" */ '../views/subOrg/jgYg.vue')
        },
        // 财务管理
        {
          path: '/finance/commissionSettlement',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'commissionSettlement',
          component: () => import( /* webpackChunkName: "statement" */ '../views/finance/commissionSettlement.vue')
        },
        // 待申请单据
        {
          path: '/finance/orgWaitReqCom',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'orgWaitReqCom',
          component: () => import( /* webpackChunkName: "statement" */ '../views/finance/orgWaitReqCom.vue')
        },
        // 设备管理
        {
          path: '/hardWareManage/equioManage',
          meta: {
            isLogin: true // 添加该字段，表示进入这个路由是需要登录的
          },
          name: 'equioManage',
          component: () => import( /* webpackChunkName: "statement" */ '../views/hardWareManage/equioManage.vue')
        },

        // {
        //     path: '/Administration/spGlXzSp',
        //     name: 'spGlXzSp',
        //     component: () => import( /* webpackChunkName: "statement" */ '../views/sp/spGlXzSp.vue')
        // }
      ]
    }
  ]

})
// 路由守卫
// router.beforeEach((to, from, next) => {
//   if (to.matched.some(res => res.meta.isLogin)) { //判断是否需要登录
//     if (!localStorage.getItem('byPayAdmin')) {
//       next({
//         path: "/login",
//       });
//       return
//     }
//     // let  partnerInfo  = JSON.parse(localStorage.getItem('byPayAdmin'))
//     if (sessionStorage.getItem('userPsw') != '' && sessionStorage.getItem('userPsw') != null) {

//       next();
//     } else {
//       next({
//         path: "/login",
//       });
//     }
//   } else {
//     next()
//   }
// });
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js